@if (selectedLocation(); as location) {
  <div class="chart">
    <header class="header">
      <h3 class="header__location-name">🌡{{location.name}}</h3>
      <div class="header__actions">
        <button
          type="button"
          class="btn btn--icon"
          (click)="close()"
        >️✖</button>
      </div>
    </header>
    <div class="chart__container">
      @if (chartData(); as data) {
        <ng-charts-line-chart
          [results]="data"
          [xAxis]="true"
          [yAxis]="true"
          [roundDomains]="true"
          [xAxisTickFormatting]="formatTime"
        ></ng-charts-line-chart>
      }
    </div>
  </div>
}
